import * as React from 'react';
import { Component } from 'react';
import { parse } from 'query-string';
import BPromise from 'bluebird';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { Loader } from 'Src/components/Loader/Loader';
import { AppUser } from 'Src/views/App/App';
import { History, Location } from 'history';
import { DATE_INTERVAL, DEFAULT_LIMIT, DEFAULT_SKIP, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { Button } from 'Src/components/Button/Button';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { ResizablePanel } from 'Src/components/ResizablePanel/ResizablePanel';
import {
  createSchoolUnionRecords,
  deleteSchoolUnionRecords,
  getAllSchoolUnionRecords,
  getSchoolUnionRecords,
  getSchoolUnionRecordsCount,
  getSportsOfRecords,
  updateSchoolUnionRecords
} from 'Src/helpers/service/adminSU/recordsTable';
import { getAgeGroup, getGender, getRecord, getYear } from 'Src/helpers/accessor/accessor';
import { Record } from 'Src/models/record';
import { RecordForm } from './RecordForm/RecordForm';
import {
  getSelectOptionForAgeRecords,
  getSelectOptionForGender,
  getSelectOptionForSport
} from 'Src/helpers/table/select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faMedal, faPen, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { ColumnToggleButton } from 'Src/components/ColumnToggleButton/ColumnToggleButton';
import { ListEmptyState } from 'Src/components/ListEmptyState/ListEmptyState';
import { loadHiddenColumns, saveHiddenColumns } from 'Src/helpers/columnVisibility/columnVisibility';
import { DatePicker as SitDatePicker } from 'Src/components/DatePicker/DatePicker';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import moment from 'moment';
import './Records.css';

const getRecordsColumnsViewKey = (user: AppUser) =>
  String(user.activeSchool && user.activeSchool.kind) === 'SchoolUnion' ? 'union.records' : 'school.records';

const isUnionRecords = (user: AppUser) =>
  String(user.activeSchool && user.activeSchool.kind) === 'SchoolUnion';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Sport',
    field: 'sport',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['sport', 'name']
  },
  {
    text: 'Age',
    field: 'agesRecord',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAgeGroup
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender
  },
  {
    text: 'Record',
    field: 'record',
    isSort: true,
    type: FILTER_TYPE.NONE,
    accessor: getRecord
  },
  {
    text: 'Athlete',
    field: 'athlete',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['athlete']
  },
  {
    text: 'Affiliation',
    field: 'area',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['area']
  },
  {
    text: 'Year',
    field: 'date',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getYear
  }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: Record[];
  currentPage: number;
  selectedItems: Record[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  sports: any[];

  isEditFormPopupOpened: boolean;
  isDeleteFormModalOpen: boolean;
  hiddenColumns: string[];
}

export class Records extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      sports: [],

      isEditFormPopupOpened: false,
      isDeleteFormModalOpen: false,
      hiddenColumns: loadHiddenColumns(props.user, getRecordsColumnsViewKey(props.user)).filter(field => field !== 'sport')
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });
    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  getColumns = (): ColumnDefinition[] =>
    isUnionRecords(this.props.user) ? COLUMNS : COLUMNS.filter(column => column.field !== 'area');

  setAdditionalItems() {
    const { user } = this.props;
    const filter = {
      limit: DEFAULT_LIMIT,
      order: 'name ASC',
      skip: DEFAULT_SKIP
    };
    return getSportsOfRecords(user, filter).then(sports => {
      this.setState({
        sports: sports
      });

      return true;
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(this.getColumns(), search);

    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order, LIMIT);

    const getRecordsPromise = getSchoolUnionRecords(user, serverQueryFilter);
    const getRecordCountPromise = getSchoolUnionRecordsCount(user, where);
    const promises = [getRecordCountPromise, getRecordsPromise];

    return BPromise.all(promises).then(([countObj, records]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection,
        sortColumnsName: sortColumnsName,
        isShowFilter: false,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: records,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    getAllSchoolUnionRecords(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = this.getColumns().find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState(
      {
        selectedItems: [],
        isSelectAllChecked: false,
        isShowFilter: false
      },
      () => {
        this.props.history.push({
          pathname: this.state.basePath,
          search: search.join('&')
        });
      }
    );
  };

  onClearFilterClick = (): void => {
    this.setState(
      {
        selectedItems: [],
        isSelectAllChecked: false,
        isShowFilter: false
      },
      () => {
        this.props.history.push({
          pathname: this.state.basePath,
          search: ''
        });
      }
    );
  };

  onCancelFilterClick = (): void => {
    this.setState({
      isShowFilter: false,
      filters: getFilters2(this.getColumns(), parse(this.props.location.search || ''))
    });
  };

  onClearFilterDraftClick = (): void => {
    const athlete = this.state.filters.athlete || '';
    this.setState({ filters: athlete ? { athlete } : {} });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onSaveButtonClick = (data): void => {
    const { user } = this.props;
    const { selectedItems } = this.state;

    this.setState({
      isLoading: true
    });

    switch (selectedItems.length) {
      case 0: {
        createSchoolUnionRecords(user, data).then(record => {
          this.setState({
            isEditFormPopupOpened: false,
            selectedItems: []
          });
          this.setItems();
        });
        break;
      }
      case 1:
        const recordId = selectedItems[0].id;
        updateSchoolUnionRecords(user, recordId, data).then(record => {
          this.setState({
            isEditFormPopupOpened: false,
            selectedItems: []
          });
          this.setItems();
        });
        break;
    }
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isEditFormPopupOpened: false,
      selectedItems: []
    });
  };

  onTabClick = (event, index: number) => {
    event.preventDefault();

    this.setState({
      total: index
    });
  };

  onEditFormClick = event => {
    event.preventDefault();

    this.setState({
      isEditFormPopupOpened: true
    });
  };

  getSummaryTabs(): React.ReactNode {
    const { selectedItems, items } = this.state;

    const selectedRecords = items.find(record => record.id === selectedItems[0].id);
    switch (true) {
      case selectedItems.length === 1:
        return <RecordSummary record={selectedRecords} />;
    }
  }

  renderForm() {
    const { isEditFormPopupOpened, selectedItems } = this.state;
    const { user } = this.props;

    switch (selectedItems.length) {
      case 0:
        return (
          <SimpleModal
            isOpen={isEditFormPopupOpened}
            title={'Create record'}
            customClass="recordsPage__modal"
            dialogStyle={{ maxWidth: 680 }}
            onCloseClick={this.onCancelButtonClick}
            showFooter={false}
          >
            <RecordForm
              isOpen={isEditFormPopupOpened}
              onCloseClick={this.onCancelButtonClick}
              onFormSubmit={this.onSaveButtonClick}
              user={user}
            />
          </SimpleModal>
        );
      case 1:
        return (
          isEditFormPopupOpened && (
            <>
              <div className="recordsPage__drawerScrim" onClick={this.onCancelButtonClick} />
              <aside className="recordsPage__drawer" role="dialog" aria-modal="true">
                <div className="recordsPage__drawerHead">
                  <span className="recordsPage__drawerIcon" aria-hidden="true">
                    ★
                  </span>
                  <div>
                    <div className="recordsPage__eyebrow">{isUnionRecords(user) ? 'Union record' : 'School record'}</div>
                    <h2>{selectedItems[0].athlete || 'Record details'}</h2>
                    <p>Review and update the performance record.</p>
                  </div>
                  <button type="button" onClick={this.onCancelButtonClick} aria-label="Close">
                    ×
                  </button>
                </div>
                <div className="recordsPage__drawerBody">
                  <div className="recordsPage__detailStats">
                    <div>
                      <span>Sport</span>
                      <strong>{selectedItems[0].sport?.name || '—'}</strong>
                    </div>
                    <div>
                      <span>Age</span>
                      <strong>{getAgeGroup(selectedItems[0]) || '—'}</strong>
                    </div>
                    <div>
                      <span>Gender</span>
                      <strong>{getGender(selectedItems[0]) || '—'}</strong>
                    </div>
                    <div>
                      <span>Record</span>
                      <strong>{getRecord(selectedItems[0]) || '—'}</strong>
                    </div>
                  </div>
                  <div className="recordsPage__formPanel">
                    <div className="recordsPage__formPanelHead">
                      <strong>Record details</strong>
                      <button type="button" onClick={this.removeFormModalOpen}>
                        Delete
                      </button>
                    </div>
                    <RecordForm
                      isOpen={isEditFormPopupOpened}
                      onCloseClick={this.onCancelButtonClick}
                      onFormSubmit={this.onSaveButtonClick}
                      record={selectedItems[0]}
                      user={user}
                    />
                  </div>
                </div>
              </aside>
            </>
          )
        );
    }
  }

  onCreateRecordClick = () => {
    this.setState({
      isEditFormPopupOpened: true,
      selectedItems: []
    });
  };

  onColumnToggle = (field: string): void => {
    if (field === 'sport') return;

    const hiddenColumns = this.state.hiddenColumns.includes(field)
      ? this.state.hiddenColumns.filter(column => column !== field)
      : [...this.state.hiddenColumns, field];

    saveHiddenColumns(this.props.user, getRecordsColumnsViewKey(this.props.user), hiddenColumns);
    this.setState({ hiddenColumns });
  };

  removeFormModalOpen = (): void => {
    this.setState({
      isDeleteFormModalOpen: true,
      isEditFormPopupOpened: false
    });
  };

  removeFormModalClose = (): void => {
    this.setState({
      isDeleteFormModalOpen: false
    });
  };

  onRemoveRecordClick = () => {
    const { selectedItems } = this.state;
    if (typeof selectedItems === 'undefined' || selectedItems.length === 0) {
      return;
    }
    this.setState({ isLoading: true });
    const promises = selectedItems.map(record => {
      return deleteSchoolUnionRecords(this.props.user, record.id);
    });
    BPromise.all(promises).then(() => {
      this.setState({
        selectedItems: [],
        isDeleteFormModalOpen: false
      });
      this.setItems();
    });
  };

  renderDeleteFormModal() {
    const { selectedItems, isDeleteFormModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteFormModalOpen}
        title={'Remove record'}
        body={`Are you sure you want to remove ${
          selectedItems.length === 1 ? `record ${selectedItems[0].athlete}` : `${selectedItems.length} records`
        }?`}
        buttonText={'Delete'}
        onButtonClick={this.onRemoveRecordClick}
        onCloseClick={this.removeFormModalClose}
      />
    );
  }

  renderSummary() {
    const { selectedItems } = this.state;
    const isOneItemSelected = selectedItems.length === 1;

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select a record above</div>;
    }

    const summaryTabs = this.getSummaryTabs();

    const isShowEditButton = selectedItems.length === 1;

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={RECORD_TABS} currentTabIndex={0}>
        {isShowEditButton && <Button onClick={this.onEditFormClick} text={'Edit record'} customClass={'mt-3 mb-3'} />}
        {summaryTabs}
      </GenericSummary>
    );
  }

  render() {
    const {
      items,
      sports,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      total,
      isEditFormPopupOpened,
      isDeleteFormModalOpen
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const selectedIds = new Set(selectedItems.map(item => item.id));
    const isPageSelected = items.length > 0 && items.every(item => selectedIds.has(item.id));
    const sortIndicator = field => (sortColumnsName === field ? (sortDirection === 'ASC' ? '↑' : '↓') : '↕');
    const filterCount = Object.keys(filters).filter(field => field !== 'athlete').map(field => filters[field]).filter(value =>
      Array.isArray(value)
        ? value.length > 0
        : Boolean(value && (typeof value !== 'object' || Object.keys(value).some(key => Boolean(value[key]))))
    ).length;
    const hiddenFields = new Set(this.state.hiddenColumns);
    const isColumnVisible = (field: string): boolean => !hiddenFields.has(field);
    const columns = this.getColumns();
    const visibleDataColumnCount = columns.filter(column => isColumnVisible(column.field)).length;
    const genderOptions = getSelectOptionForGender();
    const ageOptions = getSelectOptionForAgeRecords(this.props.user.activeSchool.ageGroupsNaming);
    const activeFilterChips = Object.keys(filters)
      .map(field => {
        const rawValue = filters[field];
        const values = Array.isArray(rawValue) ? rawValue : [rawValue];
        const column = columns.find(item => item.field === field);
        const value = values
          .filter(item => item !== '' && typeof item !== 'undefined' && item !== null)
          .map(item => {
            if (field === 'sport') {
              const sport = sports.find(option => String(option.id) === String(item));
              return sport ? sport.name : String(item);
            }
            if (field === 'gender') {
              const gender = genderOptions.find(option => String(option.value) === String(item));
              return gender ? gender.text : String(item);
            }
            if (field === 'agesRecord') {
              const age = ageOptions.find(option => String(option.value) === String(item));
              return age ? age.text : String(item);
            }
            if (item && typeof item === 'object') {
              return [item.from, item.to].filter(Boolean).join(' – ');
            }
            return String(item);
          })
          .filter(Boolean)
          .join(', ');
        return {
          field,
          label: field === 'athlete' ? 'Search' : field === 'date' ? 'Record date' : column ? column.text : field,
          value
        };
      })
      .filter(chip => Boolean(chip.value));
    const recordsOwner = isUnionRecords(this.props.user) ? 'union' : 'school';
    return (
      <div className={`recordsPage ${isEditFormPopupOpened || isDeleteFormModalOpen ? 'modal-open' : ''}`}>
        {this.renderDeleteFormModal()}
        {this.renderForm()}
        <header className="recordsPage__pageHeader">
          <div className="recordsPage__heading">
            <div className="recordsPage__title">
            <h1>Records</h1>
            <span>{total}</span>
            </div>
            <p>Manage {recordsOwner} records, athlete achievements and their competition details.</p>
          </div>
          <button type="button" className="recordsPage__create" onClick={this.onCreateRecordClick}>
            <FontAwesomeIcon icon={faPlus} /> Create record
          </button>
        </header>

        <main className="recordsPage__mainCard">
        <div className="recordsPage__toolbar">
          <label className="recordsPage__search">
            <input
              value={filters.athlete || ''}
              placeholder="Search athlete…"
              onChange={event => this.onTableFilterChange(event, 'athlete')}
              onKeyDown={event => event.key === 'Enter' && this.onApplyFilterClick()}
            />
            {filters.athlete ? (
              <button
                type="button"
                aria-label="Clear athlete search"
                onClick={() => {
                  const nextFilters = { ...filters };
                  delete nextFilters.athlete;
                  this.setState({ filters: nextFilters }, this.onApplyFilterClick);
                }}
              >
                ×
              </button>
            ) : null}
          </label>
          <button
            type="button"
            className={filterCount ? 'recordsPage__filter isActive' : 'recordsPage__filter'}
            onClick={this.onTableFilterClick}
          >
            <FontAwesomeIcon icon={faFilter} /> Filters{filterCount ? <i>{filterCount}</i> : null}
          </button>
          <ColumnToggleButton
            columns={columns}
            hiddenFields={hiddenFields}
            onToggle={this.onColumnToggle}
            isToggleable={field => field !== 'sport'}
            onReset={() => {
              saveHiddenColumns(this.props.user, getRecordsColumnsViewKey(this.props.user), []);
              this.setState({ hiddenColumns: [] });
            }}
          />
        </div>

        {activeFilterChips.length > 0 && (
          <div className="recordsPage__activeFilters" aria-label="Applied search criteria">
            {activeFilterChips.map(chip => (
              <span key={chip.field}>
                <b>{chip.label}:</b> {chip.value}
                <button
                  type="button"
                  aria-label={`Clear ${chip.label}`}
                  onClick={() => {
                    const nextFilters = { ...filters };
                    delete nextFilters[chip.field];
                    this.setState({ filters: nextFilters }, this.onApplyFilterClick);
                  }}
                >
                  ×
                </button>
              </span>
            ))}
            <button type="button" className="recordsPage__activeFiltersClear" onClick={this.onClearFilterClick}>
              Clear all
            </button>
          </div>
        )}

        {selectedItems.length > 0 && (
          <div className="recordsPage__selection">
            <strong>
              {selectedItems.length} {selectedItems.length === 1 ? 'record' : 'records'} selected
            </strong>
            <div>
              {selectedItems.length === 1 && (
                <button type="button" className="recordsPage__edit" onClick={this.onEditFormClick}>
                  <FontAwesomeIcon icon={faPen} /> Edit record
                </button>
              )}
              <button type="button" className="recordsPage__delete" onClick={this.removeFormModalOpen}>
                <FontAwesomeIcon icon={faTrash} /> Delete {selectedItems.length === 1 ? 'record' : 'records'}
              </button>
              <button type="button" className="recordsPage__clear" onClick={this.onUnselectAllClick}>
                Clear selection
              </button>
            </div>
          </div>
        )}

        <div className="recordsPage__card">
          <div className="recordsPage__scroll">
            <table className="recordsPage__table">
              <thead>
                <tr>
                  <th className="recordsPage__check">
                    <SelectAllCheckbox
                      onSelectAllClick={this.onSelectAllClick}
                      onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                      onUnselectAllClick={this.onUnselectAllClick}
                      isChecked={isPageSelected}
                      totalCount={total}
                      currentPage={currentPage}
                      selectedItems={selectedItems}
                      pageItemsCount={items.length}
                      compact={true}
                    />
                  </th>
                  {isColumnVisible('sport') && (
                    <th>
                      <button type="button" onClick={() => this.onTableSortClick('sport')}>
                        Sport <span>{sortIndicator('sport')}</span>
                      </button>
                    </th>
                  )}
                  {isColumnVisible('agesRecord') && <th>Age</th>}
                  {isColumnVisible('gender') && (
                    <th>
                      <button type="button" onClick={() => this.onTableSortClick('gender')}>
                        Gender <span>{sortIndicator('gender')}</span>
                      </button>
                    </th>
                  )}
                  {isColumnVisible('record') && (
                    <th>
                      <button type="button" onClick={() => this.onTableSortClick('record')}>
                        Record <span>{sortIndicator('record')}</span>
                      </button>
                    </th>
                  )}
                  {isColumnVisible('athlete') && (
                    <th>
                      <button type="button" onClick={() => this.onTableSortClick('athlete')}>
                        Athlete <span>{sortIndicator('athlete')}</span>
                      </button>
                    </th>
                  )}
                  {isUnionRecords(this.props.user) && isColumnVisible('area') && (
                    <th>
                      <button type="button" onClick={() => this.onTableSortClick('area')}>
                        Affiliation <span>{sortIndicator('area')}</span>
                      </button>
                    </th>
                  )}
                  {isColumnVisible('date') && (
                    <th>
                      <button type="button" onClick={() => this.onTableSortClick('date')}>
                        Year <span>{sortIndicator('date')}</span>
                      </button>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {items.map((record, index) => (
                  <tr
                    key={record.id}
                    className={selectedIds.has(record.id) ? 'isSelected' : ''}
                    onClick={() => this.setState({ selectedItems: [record], isEditFormPopupOpened: true })}
                  >
                    <td className="recordsPage__check" onClick={event => event.stopPropagation()}>
                      <input
                        type="checkbox"
                        checked={selectedIds.has(record.id)}
                        onChange={() => this.onItemClick(index)}
                      />
                    </td>
                    {isColumnVisible('sport') && (
                      <td>
                        <strong>{record.sport?.name || '—'}</strong>
                      </td>
                    )}
                    {isColumnVisible('agesRecord') && <td>{getAgeGroup(record) || '—'}</td>}
                    {isColumnVisible('gender') && (
                      <td>
                        <span className="recordsPage__gender">{getGender(record) || '—'}</span>
                      </td>
                    )}
                    {isColumnVisible('record') && (
                      <td>
                        <span className="recordsPage__value">{getRecord(record)}</span>
                      </td>
                    )}
                    {isColumnVisible('athlete') && (
                      <td>
                        <strong>{record.athlete || '—'}</strong>
                      </td>
                    )}
                    {isUnionRecords(this.props.user) && isColumnVisible('area') && <td>{record.area || '—'}</td>}
                    {isColumnVisible('date') && <td>{getYear(record) || '—'}</td>}
                  </tr>
                ))}
                {items.length === 0 && (
                  <tr>
                    <td colSpan={visibleDataColumnCount + 1} className="recordsPage__empty">
                      <ListEmptyState
                        icon={faMedal}
                        title={activeFilterChips.length > 0 ? 'No records match your filters' : 'No records yet'}
                        description={
                          activeFilterChips.length > 0
                            ? 'Try changing or clearing the search and filters to see more records.'
                            : `${isUnionRecords(this.props.user) ? 'Union' : 'School'} records and athlete achievements will appear here when they are added.`
                        }
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {total > 0 && (
          <div className="recordsPage__pagination">
            <Pagination2
              currentPage={currentPage}
              setCurrentPageParams={this.setCurrentPageParams}
              total={total}
              modern={true}
            />
          </div>
        )}
        </main>

        {isShowFilter && (
          <>
            <div className="recordsPage__scrim" onClick={this.onCancelFilterClick} />
            <aside
              className="recordsPage__filters"
              onKeyDown={event => {
                if (event.key === 'Enter' && (event.target as HTMLElement).tagName !== 'BUTTON') {
                  event.preventDefault();
                  this.onApplyFilterClick();
                }
              }}
            >
              <header>
                <div>
                  <h2>Filters</h2>
                </div>
                <button type="button" onClick={this.onCancelFilterClick} aria-label="Close filters">
                  ×
                </button>
              </header>
              <div className="recordsPage__filterBody">
                <label>
                  Sport
                  <select
                    value={(filters.sport || [])[0] || ''}
                    onChange={event =>
                      this.setState({ filters: { ...filters, sport: event.target.value ? [event.target.value] : [] } })
                    }
                  >
                    <option value="">All sports</option>
                    {sports.map(sport => (
                      <option key={sport.id} value={sport.id}>
                        {sport.name}
                      </option>
                    ))}
                  </select>
                </label>
                <fieldset className="recordsPage__filterField">
                  <legend>Gender</legend>
                  <div className="recordsPage__filterChips">
                    {genderOptions.map(option => {
                      const value = String(option.value);
                      const isSelected = (filters.gender || []).map(String).includes(value);
                      return (
                        <button
                          type="button"
                          key={value}
                          className={isSelected ? 'is-selected' : ''}
                          aria-pressed={isSelected}
                          onClick={() => this.setState({ filters: { ...filters, gender: isSelected ? [] : [value] } })}
                        >
                          {option.text}
                        </button>
                      );
                    })}
                  </div>
                </fieldset>
                <fieldset className="recordsPage__filterField">
                  <legend>Age</legend>
                  <div className="recordsPage__filterChips">
                    {ageOptions.map(option => {
                      const value = String(option.value);
                      const selectedAges = (filters.agesRecord || []).map(String);
                      const isSelected = selectedAges.includes(value);
                      return (
                        <button
                          type="button"
                          key={value}
                          className={isSelected ? 'is-selected' : ''}
                          aria-pressed={isSelected}
                          onClick={() =>
                            this.setState({
                              filters: {
                                ...filters,
                                agesRecord: isSelected
                                  ? selectedAges.filter(age => age !== value)
                                  : [...selectedAges, value]
                              }
                            })
                          }
                        >
                          {option.text}
                        </button>
                      );
                    })}
                  </div>
                </fieldset>
                <div className="recordsPage__dateFilter">
                  <SitDatePicker
                    className="recordsPage__datePicker"
                    label="Record date"
                    mode="range"
                    value={{
                      start:
                        filters.date && filters.date.from ? moment(filters.date.from, 'DD-MM-YYYY').toDate() : null,
                      end: filters.date && filters.date.to ? moment(filters.date.to, 'DD-MM-YYYY').toDate() : null
                    }}
                    onChange={(range: any) =>
                      this.setState({
                        filters: {
                          ...filters,
                          date: {
                            from: range && range.start ? moment(range.start).format('DD-MM-YYYY') : '',
                            to: range && range.end ? moment(range.end).format('DD-MM-YYYY') : ''
                          }
                        }
                      })
                    }
                    format="DD-MM-YYYY"
                    placeholder="Select date range"
                    numberOfMonths={2}
                    align="right"
                    clearable={true}
                    syncRangeOnSelect={true}
                  />
                </div>
                {isUnionRecords(this.props.user) && (
                  <label>
                    Affiliation
                    <input
                      value={filters.area || ''}
                      placeholder="Search affiliation…"
                      onChange={event => this.onTableFilterChange(event, 'area')}
                    />
                  </label>
                )}
              </div>
              <footer>
                <button type="button" className="recordsPage__clearFilters" onClick={this.onClearFilterDraftClick}>
                  Clear all
                </button>
                <div>
                  <button type="button" onClick={this.onCancelFilterClick}>Cancel</button>
                  <button type="button" className="recordsPage__applyFilters is-apply" onClick={this.onApplyFilterClick}>
                    Apply
                  </button>
                </div>
              </footer>
            </aside>
          </>
        )}
      </div>
    );
  }
}
